/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PieChartThreeDIcon = /*#__PURE__*/ createSvgIcon(
  'PieChartThreeDIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M9.5.5h.5a9.5 9.5 0 019.5 9.5v.5h-10V.5zm1 1.015V9.5h7.985A8.5 8.5 0 0010.5 1.515z" />
            <path d="M14 10V2.21h1V10h-1zM16.25 10V4.04h1V10h-1zM11.75 10V1.29h1V10h-1zM3.389 7.595A6.5 6.5 0 017 6.5h.5v6h6v.5A6.5 6.5 0 113.389 7.595zM6.5 7.523a5.5 5.5 0 105.977 5.977H6.5V7.523z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default PieChartThreeDIcon;
